import type SurfaceActionIcons from './SurfaceActionIcons';

export type SurfaceActionIconsSubset = { [icon in SurfaceActionIcons]: string };

export const SurfaceActionIconsDefinitions: SurfaceActionIconsSubset = {
    InsertSignatureLine: '\uf677',
    ArrangeByFrom: '\uf678',
    Phishing: '\uf679',
    CreateMailRule: '\uf67A',
    Encryption: '\uf69D',
    ReadOutLoud: '\uf112',
};

const registration: {
    fontFileName: string;
    icons: SurfaceActionIconsSubset;
} = {
    fontFileName: 'surfaceActionIcons',
    icons: SurfaceActionIconsDefinitions,
};
export default registration;
